<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Servizi</h1>
        <b-tabs v-model="selectedTab">
          <b-tab-item label="Tabella">
            <div style="cursor: pointer">
              <b-table
                :data="rowData"
                :columns="columns"
                :striped="true"
                :paginated="true"
                :per-page="15"
                :pagination-simple="false"
                :selected.sync="selected"
                @select="select"
                @click="rowClicked"
              >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small"
                />
              </b-table>
            </div>
            <section>
              <div class="buttons">
                <b-button @click="doNew" type="is-primary">Nuovo</b-button>
              </div>
            </section>
          </b-tab-item>

          <b-tab-item label="Azioni" disabled>
            <div class="column is-half" ref="form">
              <section>
                <span v-if="newItem.Id" class="subtitle"
                  >Id: {{ newItem.Id }}</span
                >
                <b-field label="Nome">
                  <b-input
                    ref="input1"
                    v-model="newItem.Name"
                    required
                    validation-message="Scrivi qualcosa!"
                  ></b-input>
                </b-field>
                <b-field label="Sala">
                  <b-input
                    ref="input2"
                    v-model="newItem.Room"
                    required
                    validation-message="Scrivi qualcosa!"
                  ></b-input>
                </b-field>
                <b-field label="Città">
                  <b-select v-model="newItem.City_id">
                    <option
                      v-for="city in citiesData"
                      :value="city.Id"
                      :key="city.Id"
                    >
                      {{ city.City }}
                    </option>
                  </b-select>
                </b-field>
                <div class="field">
                  <b-checkbox v-model="newItem.Active">Attivo</b-checkbox>
                  <b-checkbox v-model="newItem.Is_tv">TV</b-checkbox>
                </div>
              </section>
              <section>
                <div class="buttons">
                  <b-button @click="doEdit" type="is-primary">Salva</b-button>
                  <b-button
                    @click="doDelete"
                    v-show="newItem.Id != 0"
                    type="is-dark"
                    >Scancella</b-button
                  >
                </div>
              </section>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

let emptyVal = {
  Id: 0,
  Name: "",
  Room: "",
  City_id: null,
  Is_tv: false,
  Active: true,
};

export default {
  name: "friend",

  methods: {
    buildData(rows) {
      rows.forEach((x) => {
        let city = this.citiesData.filter((y) => {
          return y.Id == x.City_id;
        })[0];
        if (city) x.City = city.City;
      });
      this.rowData = rows;
    },
    doDelete() {
      this.$buefy.dialog.confirm({
        message: "Lo scancello sul serio?",
        onConfirm: () => {
          const loading = this.$buefy.loading.open();
          api.service
            .delete(this.newItem.Id)
            .then(() => {
              return api.service.getAll();
            })
            .then((rows) => {
              this.buildData(rows.data);
              helpers.ok("Service correttamente scancellato");
              this.newItem = emptyVal;
              this.selectedTab = 0;
              loading.close();
            })
            .catch((err) => {
              helpers.error("Errore! " + err);
              loading.close();
            });
        },
      });
    },
    doNew() {
      this.newItem = emptyVal;
      this.selectedTab = 1;
    },

    doEdit() {
      if (!this.$refs["input1"].checkHtml5Validity()) {
        return;
      }
      let apiMethod =
        this.newItem.Id != 0 ? api.service.update : api.service.create;
      const loading = this.$buefy.loading.open();
      apiMethod(this.newItem)
        .then(() => {
          return api.service.getAll();
        })
        .then((rows) => {
          this.buildData(rows.data);
          helpers.ok("Servizio correttamente salvato");
          this.newItem = emptyVal;
          this.selectedTab = 0;
          loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
          loading.close();
        });
    },
    rowClicked(row) {
      if (row.Id == this.newItem.Id) {
        this.selected = null;
        this.newItem = emptyVal;
      } else {
        this.selectedTab = 1;
      }
    },
    select(row) {
      this.newItem = row;
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      rowData: [],
      citiesData: [],
      selected: null,
      selectedTab: 0,
      columns: [
        {
          field: "Id",
          label: "Id",
          width: "40",
          numeric: true,
        },
        {
          field: "Name",
          label: "Nome",
          searchable: true,
          sortable: true,
        },
        {
          field: "Room",
          label: "Sala",
        },
        {
          field: "City",
          label: "Città",
          searchable: true,
          sortable: true,
        },
        {
          field: "Is_tv",
          label: "TV",
        },
        {
          field: "Active",
          label: "Attivo",
        },
      ],
    };
  },
  mounted() {
    const loading = this.$buefy.loading.open();
      api.city.getAll().then((rows) => {
        this.citiesData = rows.data;
        return api.service.getAll()
      })
        .then((rows) => {
        this.buildData(rows.data);
        this.rowData = rows.data;
        loading.close();
    });
  },
};
</script>

<style>
</style>